import type { Client, RequestContext } from "../client";
import type { PagingCollection, ProjectResource, EphemeralEnvironmentTaskStatusResource } from "../resources";
export type GetEphemeralEnvironmentsForProjectBffResponse = {
    Environments: PagingCollection<ProjectEphemeralEnvironmentDetail>;
    StatusCounts: ProjectEphemeralEnvironmentStatusCounts;
};
export type ProjectEphemeralEnvironmentStatusCounts = {
    Provisioning: number;
    Provisioned: number;
    ProvisioningFailed: number;
    Deprovisioning: number;
    Deprovisioned: number;
    DeprovisioningFailed: number;
};
export type EphemeralEnvironmentProjectStatus = "NotProvisioned" | "Provisioning" | "ProvisioningFailed" | "Provisioned" | "Deprovisioning" | "DeprovisioningFailed" | "Deprovisioned";
export type ProjectEphemeralEnvironmentDetail = {
    Id: string;
    Status: EphemeralEnvironmentProjectStatus;
    Name: string;
    LatestDeployment?: EphemeralEnvironmentTaskStatusResource;
    ProvisioningRunbookRun?: EphemeralEnvironmentTaskStatusResource;
    DeprovisioningRunbookRun?: EphemeralEnvironmentTaskStatusResource;
};
export class EphemeralEnvironmentRepository {
    protected client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    async getForProject(project: ProjectResource, skip: number, take: number, name?: string, status?: EphemeralEnvironmentProjectStatus) {
        return await this.client.get<GetEphemeralEnvironmentsForProjectBffResponse>(this.requestContext, "~/bff/spaces/{spaceId}/projects/{projectId}/ephemeral-environments{?skip,take,name,status}", {
            spaceId: project.SpaceId,
            projectId: project.Id,
            skip: skip,
            take: take,
            name: name,
            status: status,
        });
    }
    async deprovision(spaceId: string, id: string) {
        return await this.client.post(this.requestContext, "~/api/spaces/{spaceId}/environments/ephemeral/{id}/deprovision", undefined, { spaceId, id });
    }
    async retryProvisioning(spaceId: string, projectId: string, environmentId: string) {
        return await this.client.post(this.requestContext, "~/api/spaces/{spaceId}/projects/{projectId}/environments/ephemeral/{environmentId}/provisioning/retry", undefined, { spaceId, projectId, environmentId });
    }
    async retryDeprovisioning(spaceId: string, projectId: string, environmentId: string) {
        return await this.client.post(this.requestContext, "~/api/spaces/{spaceId}/projects/{projectId}/environments/ephemeral/{environmentId}/deprovisioning/retry", undefined, { spaceId, projectId, environmentId });
    }
    async markProvisioningSuccessful(spaceId: string, projectId: string, environmentId: string) {
        return await this.client.post(this.requestContext, "~/api/spaces/{spaceId}/projects/{projectId}/environments/ephemeral/{environmentId}/provisioning/mark-successful", undefined, { spaceId, projectId, environmentId });
    }
    async markDeprovisioningSuccessful(spaceId: string, projectId: string, environmentId: string) {
        return await this.client.post(this.requestContext, "~/api/spaces/{spaceId}/projects/{projectId}/environments/ephemeral/{environmentId}/deprovisioning/mark-successful", undefined, { spaceId, projectId, environmentId });
    }
}
